export default {
  data() {
    return {
      liveId: '',
      schoolName: '',
      streamStatus: ''
    };
  },
  created() {
    this.liveId = this.$route.params.liveId;
    this.schoolName = this.$route.params.schoolName;
    this.streamStatus = this.$route.params.streamStatus;
  }
};
